import React, { useState } from 'react';

export interface Props {
  text: string;
  type: string;
  placeholder: string;
  children: any;
  setEditingState(editingState: boolean): void;
}

export const InlineEditable = (props: Props) => {
  const [isEditing, setEditing] = useState(false);
  const { text, type, placeholder, children } = props;
  let timeout = 0;

  const handleEditing = (editingState: boolean) => {
    const { setEditingState } = props;

    setEditing(editingState);
    setEditingState(editingState);
  };

  const handleKeyDown = (event: React.KeyboardEvent, type: string) => {
    const { key } = event;
    const keys = ['Escape', 'Tab', 'Enter'];
    if (keys.indexOf(key) > -1) {
      if (timeout) clearTimeout(timeout);

      timeout = window.setTimeout(() => {
        handleEditing(false);
      }, 100);
    }
  };

  return (
    <section>
      {isEditing ? (
        <div onBlur={() => handleEditing(false)} onKeyDown={(e) => handleKeyDown(e, type)}>
          {children}
        </div>
      ) : (
        <div onClick={() => handleEditing(true)}>
          <span>{text || placeholder}</span>
        </div>
      )}
    </section>
  );
};
